import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { SpecraActivityFeed } from '../captains/activity-feed';
/** Record detail layout with main content, context rail, and optional activity. */ export const SpecraDetailPage = /*#__PURE__*/ React.forwardRef(({ activity, aside, children, className, footer, header, ...props }, ref)=>/*#__PURE__*/ _jsxs("div", {
        className: cn('mx-auto w-full max-w-7xl p-4 sm:p-6', className),
        ref: ref,
        ...props,
        children: [
            header,
            /*#__PURE__*/ _jsxs("div", {
                className: cn('mt-5 grid gap-5 sm:mt-6 sm:gap-6', aside && 'lg:grid-cols-[minmax(0,1fr)_var(--component-detail-aside-width)]'),
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "min-w-0 space-y-6",
                        children: [
                            children,
                            activity ? /*#__PURE__*/ _jsx(SpecraActivityFeed, {
                                ...activity
                            }) : null,
                            footer
                        ]
                    }),
                    aside ? /*#__PURE__*/ _jsx("aside", {
                        className: "min-w-0",
                        children: aside
                    }) : null
                ]
            })
        ]
    }));
SpecraDetailPage.displayName = 'SpecraDetailPage';
